<template>
  <div class="search-wrap">
    <div></div>
    <div class="search-bar border">
      <select class="form-select sm border-none" v-model="search.searchType">
        <option value="">전체</option>
        <option v-for="(item, idx) in codeList" :key="idx" :value="item.cd">
          {{ item.cdNm }}
        </option>
      </select>
      <input
        type="text"
        class="form-control sm border-none"
        placeholder="검색어를 입력하세요."
        v-model="search.searchText"
        @keyup.enter="fnSearch"
      />
      <button class="btn-ico xsm ico-sch" @click="fnSearch">
        <span class="sr-only">검색</span>
      </button>
    </div>
  </div>
  <div class="content-zone">
    <div class="content">
      <div class="scroll">
        <div class="tbl-wrap">
          <ListTable
            class="data cursor"
            :colgroup="colgroup"
            :thead="thead"
            :tbody="tbody"
            :columnAlign="columnAlign"
            @listClick="fnView"
            :lockList="lockList"
            :ntcList="ntcList"
          >
            <template #notice>
              <div class="img">
                <img :src="getThemeImageUrl('announce_icon.png')" />
              </div>
            </template>
          </ListTable>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-wrap list">
    <div></div>
    <PaginationButton
      class="admin-pagination"
      v-model:currentPage="search.currentPage"
      :pagination="search"
      :click="findAll"
    />
    <button v-if="hasAccessByType('create')" class="btn sm main" @click="fnAdd">
      등록
    </button>
  </div>
</template>
<script>
import ListTable from "../../../../../component/table/ListTable.vue";
import PaginationButton from "../../../../../component/pagination/PaginationButton.vue";
import { findAll } from "../../../../../../resources/api/bbsCn.js";
import { toRaw } from "vue";
import queryParams from "../../../../../../resources/js/queryParams.js";
import { defaultSearchParams } from "../../../../../../resources/js/defaultSearchParams.js";

export default {
  mixins: [queryParams],

  components: {
    ListTable: ListTable,
    PaginationButton: PaginationButton,
  },

  data() {
    return {
      colgroup: ["10%", "45%", "13%", "22%", "10%"],
      thead: ["NO", "제목", "첨부파일", "작성일", "조회수"],
      columnAlign: {
        id: "center",
        attachFile: "center",
        wrtDt: "center",
        inqCnt: "center",
      },
      tbody: [],
      search: { ...defaultSearchParams },
      path: this.$store.state.path,
      pageAuth: this.$store.state.pageAuth,
      mbrId: this.$store.state.mbrId,
      roles: this.$store.state.roles[0].authority,
      list: [], // 게시판 내용 목록
      listCnt: 0,
      pagination: {},
      bbsMngId: "", // 게시판 관리 아이디
      codeList: [
        { cd: "bbsNm", cdNm: "제목" },
        { cd: "bbsCn", cdNm: "내용" },
        { cd: "mbrNm", cdNm: "작성자" },
      ], // 검색 조건
      bbsMng: {}, // 게시판 관리
      lockList: [],
      ntcList: [],
      selectedSortBtn: "registration",
      isMobile: false,
    };
  },

  computed: {
    refreshPath() {
      return this.$iconPath("mdiRefresh");
    },
  },

  created() {
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);
  },

  // 컴포넌트(페이지) 초기 진입 시
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fnInit();
    });
  },

  // 동일 컴포넌트로 재진입 시
  beforeRouteUpdate(to, from, next) {
    this.fnInit();
    next();
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkDevice);
  },

  methods: {
    // 검색 (검색조건 변경 시 1페이지부터 조회)
    fnSearch() {
      this.search.currentPage = 1;
      this.findAll();
    },

    // 목록 조회
    async findAll() {
      this.saveQueryParams("queryParams", this.search); // 검색조건 저장
      this.search.id = this.bbsMngId;
      try {
        const res = await findAll(toRaw(this.search));
        this.list = res.data.data.list; // 게시판 관리 목록
        this.listCnt = res.data.data.pagination.totalRecordCount; // 게시판 관리 목록 갯수
        this.search = res.data.data.pagination; // 페이징처리 및 검색 내용
        this.bbsMng = res.data.data.bbsMng;
        this.lockList = [];
        this.ntcList = [];
        this.makeTbody();
      } catch (error) {
        const errorData = error.response.data;
        if (errorData.message != null && errorData.message != "") {
          alert(error.response.data.message);
        } else {
          alert("에러가 발생했습니다.\n관리자에게 문의해주세요.");
        }
      }
    },

    // 상세 조회
    fnView(idx) {
      this.saveQueryParams("queryParams", this.search); // 검색조건 저장
      this.$router.push({
        path: this.path + "/view.page",
        query: {
          pageId: this.list[idx]["bbsId"],
        },
      });
    },

    // 등록페이지 이동
    fnAdd() {
      this.$router.push({
        // name: 'CommonInsert_' + this.bbsMngId,
        path: this.path + "/insert.page",
      });
    },

    // 비밀글 / 공지 체크
    getPrvtYnCk(bbsMng, idx) {
      // 공지글 체크
      if (bbsMng.nowNtcYn === "Y") {
        this.ntcList.push(idx);
      }
      //비밀글 체크
      if (bbsMng.prvtPstYn === "Y") {
        this.lockList.push(idx);

        // 작성자와 로그인한 사용자가 같거나, 로그인한 사용자가 관리자 일 경우 title 표시
        if (bbsMng.rgtr != this.mbrId && this.roles != "ROLE_ADMIN") {
          return "[ 비밀글입니다 ]";
        }
      }
      return bbsMng.bbsNm;
    },

    // tbody 생성
    makeTbody() {
      // 초기화
      this.tbody = [];

      this.tbody = this.list.map((bbsMng, idx) => ({
        id:
          this.listCnt -
          idx -
          (this.search.currentPage - 1) * this.search.recordSize, // 번호
        bbsNm: this.getPrvtYnCk(bbsMng, idx), // 제목
        //wrtrNm: bbsMng.rgtrNm, // 작성자
        attachFile: bbsMng.fileList ? bbsMng.fileList.length : 0, // 첨부파일 - 레이아웃 때문에 일단 임의의 값을 넣어둠 (추후 수정하기)
        wrtDt: bbsMng.regDt, // 작성일
        inqCnt: bbsMng.inqCnt, // 조회수
        isNotice: bbsMng.nowNtcYn, // 공지사항 노출 유무(공지기간 반영)
      }));
    },

    // 검색 조건 초기화
    fnSearchReset() {
      this.search = { ...defaultSearchParams };
      this.findAll();
    },

    // 초기 조회
    fnInit() {
      this.fnBbsIdExtraction();
      this.restoreQueryParams("queryParams");
      this.findAll();
    },

    checkDevice() {
      this.isMobile = window.innerWidth <= 767;
    },
  },
};
</script>
